
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kb7fE", function(module, exports) {

var $56QzY = parcelRequire("56QzY");

const $bf0d0b0ce0cea3ff$export$881973c738c61a54 = (createAnalyticsEvent, spaceViewsSort, contentTreeSize)=>(id)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'pageTree',
                source: 'pageTree',
                objectId: id,
                attributes: {
                    spaceView: spaceViewsSort,
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    contentTreeSize: contentTreeSize
                }
            }
        }).fire();
    };
const $bf0d0b0ce0cea3ff$export$c4f6678ae42378e7 = (createAnalyticsEvent, selection)=>(option)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: option,
                source: 'spaceViewsMenu',
                attributes: {
                    spaceView: selection
                }
            }
        }).fire();
    };
const $bf0d0b0ce0cea3ff$export$5847ea5820c9d9b3 = (createAnalyticsEvent, selection)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spaceViews',
                source: 'spaceViewsMenu',
                attributes: {
                    spaceView: selection
                }
            }
        }).fire();
    };
module.exports["fireItemClickedAnalytics"] = $bf0d0b0ce0cea3ff$export$881973c738c61a54;
module.exports["fireSpaceViewsOptionClickedAnalytics"] = $bf0d0b0ce0cea3ff$export$c4f6678ae42378e7;
module.exports["fireSpaceViewsTriggerClickedAnalytics"] = $bf0d0b0ce0cea3ff$export$5847ea5820c9d9b3;

});

parcelRegister("3QuUN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $56QzY = parcelRequire("56QzY");

const $e505c1ab3313693e$export$ec83916a1ca3a7c = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'customHomepage',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$5fa0d2139c0e0457 = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'home',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$22e0f3cc7763cf21 = (createAnalyticsEvent, routeDataRef)=>(isExpanded, shortcut = false, hidden = false)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'recent',
                attributes: {
                    shortcut: shortcut,
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: hidden,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    status: isExpanded ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$4df5acfd72120215 = (createAnalyticsEvent, routeDataRef)=>(isExpanded, shortcut = false, hidden = false)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'starred',
                attributes: {
                    shortcut: shortcut,
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: hidden,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    status: isExpanded ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$4a4f812c5044dd68 = (createAnalyticsEvent, routeDataRef)=>(isExpanded)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'spaces',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    status: isExpanded ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$73f946f07ef7a83 = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'drafts',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$a5c138d597a6df57 = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'teams',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    gasEnabled: (0, $9wGTI.fg)('nav4_global_links_confluence')
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$d6cf8dac1ccaf0a0 = (createAnalyticsEvent, routeDataRef)=>(isExpanded)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'apps',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    status: isExpanded ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$778cf75bc827be5c = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'tasks',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$144ccba5c4c7989e = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'templates',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.TOUCH)
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$d80bafd2b77a80e0 = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'customiseSidebar',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: false,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.TOUCH)
                }
            }
        }).fire();
    };
const $e505c1ab3313693e$export$42127e59045e61e = (createAnalyticsEvent, routeDataRef)=>(menuId)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: menuId,
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    isInMore: true,
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
module.exports["fireCustomHomepageClickedAnalytics"] = $e505c1ab3313693e$export$ec83916a1ca3a7c;
module.exports["fireHomeClickedAnalytics"] = $e505c1ab3313693e$export$5fa0d2139c0e0457;
module.exports["fireRecentsClickedAnalytics"] = $e505c1ab3313693e$export$22e0f3cc7763cf21;
module.exports["fireStarredClickedAnalytics"] = $e505c1ab3313693e$export$4df5acfd72120215;
module.exports["fireSpacesClickedAnalytics"] = $e505c1ab3313693e$export$4a4f812c5044dd68;
module.exports["fireDraftsClickedAnalytics"] = $e505c1ab3313693e$export$73f946f07ef7a83;
module.exports["fireTeamsClickedAnalytics"] = $e505c1ab3313693e$export$a5c138d597a6df57;
module.exports["fireAppsClickedAnalytics"] = $e505c1ab3313693e$export$d6cf8dac1ccaf0a0;
module.exports["fireTasksClickedAnalytics"] = $e505c1ab3313693e$export$778cf75bc827be5c;
module.exports["fireTemplatesClickedAnalytics"] = $e505c1ab3313693e$export$144ccba5c4c7989e;
module.exports["fireCustomizeSidebarClickedAnalytics"] = $e505c1ab3313693e$export$d80bafd2b77a80e0;
module.exports["fireMoreMenuClickedAnalytics"] = $e505c1ab3313693e$export$42127e59045e61e;

});

parcelRegister("7Hd8C", function(module, exports) {
const $8f8f6148298e1591$export$54cb9d78cdd42b49 = (createAnalyticsEvent, navVersion, options = {})=>()=>{
        const { componentType: componentType, itemId: itemId, itemType: itemType, section: section, parentItemType: parentItemType, parentItemId: parentItemId, isGuest: isGuest } = options;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'spacesNavigationMenuItem',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: navVersion,
                    componentType: componentType,
                    itemId: itemId,
                    itemType: itemType,
                    section: section,
                    parentItemType: parentItemType,
                    parentItemId: parentItemId,
                    isGuest: isGuest
                }
            }
        }).fire();
    };
module.exports["fireSpacesMenuItemClickedAnalytics"] = $8f8f6148298e1591$export$54cb9d78cdd42b49;

});

parcelRegister("7vGOX", function(module, exports) {
const $bcf8984225907b60$export$f7f1be0a2cae47aa = (createAnalyticsEvent)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'appsNavigationMenuItem',
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: '4',
                    componentType: 'fixedItemButton',
                    itemId: 'meatballDropdown'
                }
            }
        }).fire();
    };
const $bcf8984225907b60$export$9e805b9ba62460e9 = (createAnalyticsEvent, itemId)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: 'appsNavigationMenuItem',
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: '4',
                    componentType: 'fixedItemAction',
                    parentItemId: 'apps',
                    itemId: itemId
                }
            }
        }).fire();
    };
const $bcf8984225907b60$export$70d18dbc8c1ee19b = (createAnalyticsEvent, itemId)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'appsNavigationMenuItem',
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: '4',
                    componentType: 'customItem',
                    itemType: 'app',
                    itemId: itemId,
                    section: 'yourApps'
                }
            }
        }).fire();
    };
module.exports["fireAppsMoreActionsButtonClicked"] = $bcf8984225907b60$export$f7f1be0a2cae47aa;
module.exports["fireAppsMoreActionsDropdownItemClicked"] = $bcf8984225907b60$export$9e805b9ba62460e9;
module.exports["fireAppsNavigationItemClicked"] = $bcf8984225907b60$export$70d18dbc8c1ee19b;

});

parcelRegister("a1jdv", function(module, exports) {
const $c8946d13826fc5c2$export$f7f1be0a2cae47aa = (createAnalyticsEvent)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'appsNavigationMenuItem',
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: '4',
                    componentType: 'fixedItemButton',
                    itemId: 'meatballDropdown'
                }
            }
        }).fire();
    };
const $c8946d13826fc5c2$export$9e805b9ba62460e9 = (createAnalyticsEvent, itemId)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: 'appsNavigationMenuItem',
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: '4',
                    componentType: 'fixedItemAction',
                    parentItemId: 'apps',
                    itemId: itemId
                }
            }
        }).fire();
    };
module.exports["fireAppsMoreActionsButtonClicked"] = $c8946d13826fc5c2$export$f7f1be0a2cae47aa;
module.exports["fireAppsMoreActionsDropdownItemClicked"] = $c8946d13826fc5c2$export$9e805b9ba62460e9;

});

parcelRegister("1FDBc", function(module, exports) {

var $56QzY = parcelRequire("56QzY");

const $3f9ae7481a55baac$export$d04fa04c0f4b508b = (createAnalyticsEvent, routeName)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'productLogo',
                attributes: {
                    selectedItemPageContext: routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
const $3f9ae7481a55baac$export$fd5ffd6321d6a027 = (createAnalyticsEvent, routeName)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'notifications',
                attributes: {
                    selectedItemPageContext: routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
const $3f9ae7481a55baac$export$91093e64447b812c = (createAnalyticsEvent, routeName, isExternalCollaborator)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'profile',
                attributes: {
                    selectedItemPageContext: routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    is_guest: isExternalCollaborator
                }
            }
        }).fire();
    };
module.exports["fireLogoClickedAnalytics"] = $3f9ae7481a55baac$export$d04fa04c0f4b508b;
module.exports["fireNotificationsClickedAnalytics"] = $3f9ae7481a55baac$export$fd5ffd6321d6a027;
module.exports["fireProfileClickedAnalytics"] = $3f9ae7481a55baac$export$91093e64447b812c;

});


//# sourceMappingURL=analyticsCallbacks.c5d35cab.js.map
